/*
 inputSlider

 Custom Knockout bindingHandler for rendering a jQuery UI slider

  Expects the following values to be passed in:
 -- min: the minimum value for the slider.
 -- max: the maximum value for the slider. 
 -- value: an observable or js number value that the slider value will be bound to.
 -- step: the step value for the slider to increment and decrement by.
 -- textDisplay: the location to display the text value ("handle", "top").
 -- textValues: an array of string text values that will be displayed when the slider value changes. Based on the index of range values.

 */

import $ from 'jquery';
import ko from 'knockout';
import _ from 'lodash';

var inputSlider = {};

//Custom dropdown binding handler
ko.bindingHandlers.inputSlider = inputSlider = {
  init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
    // This will be called when the binding is first applied to an element
    // Set up any initial state, event handlers, etc. here
  },
  update: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
    // This will be called once when the binding is first applied to an element,
    // and again whenever any observables/computeds that are accessed change
    // Update the DOM element based on the supplied values here.  

    var props = valueAccessor();

    var $element = $(element);

    //Add the css class for our slider
    $element.addClass("input-slider");

    var min = props.min || 0;
    var max = props.max || 1;
    var step = props.step || 0;
    var value = ko.isObservable(props.value) ? props.value() || min : props.value || min;
    var valueObservable = ko.isObservable(props.value) ? props.value : undefined;
    var textValues = props.textValues;
    var textDisplay = props.textDisplay || "hide";  //could be handle or top

    var slider = $element.slider({
      range: "min",
      value: value,
      min: min,
      max: max,
      step: step,
      slide: function (event, ui) {

        inputSlider.updateSliderTooltip($element, ui.value, textValues, min, max);

        if (valueObservable)
          valueObservable(ui.value);
      },
      create: function (event, ui) {

        inputSlider.createSliderTooltip($element, textDisplay);
      }
    });
    
    inputSlider.updateSliderTooltip($element, value, textValues, min, max);

  },
  updateSliderTooltip: function ($element, value, textValues, min, max) {

    var tooltipText = value;

    var indexOffsetFromZero = min - 0;

    if (textValues && textValues.length > 0) {
      var textValue = _.nth(textValues, value - indexOffsetFromZero)
      if (textValue)
        tooltipText = textValue.toString();
    }

    var $tooltip = $element.find('.input-slider-text');
    $tooltip.text(tooltipText);
  },
  createSliderTooltip: function ($element, textDisplay) {

    var $tooltip = $('<div class="input-slider-text" />');

    if (textDisplay == "handle") {
      var $handle = $element.find('.ui-slider-handle');
      $handle.append($tooltip);
      $tooltip.addClass("handle");
    }
  }
};
